import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { environment } from 'src/environments/environment';
import { SucessoComponent } from '../../sucesso/sucesso.component';

@Component({
  selector: 'app-descarte-tarefa',
  standalone: true,
  imports: [CommonModule, FormsModule, SucessoComponent],
  templateUrl: './descarte-tarefa.component.html',
  styleUrls: ['./descarte-tarefa.component.scss'],
})
export class DescarteTarefaComponent implements OnInit {
  @Input() idObra: number | null = null;
  @Input() tarefa: any = null;
  @Output() close = new EventEmitter<void>();
  @Output() tarefaDescartada = new EventEmitter<void>();
  @Output() loading = new EventEmitter<boolean>();
  sucessoDescarteTarefa = false;
  confirmarDescarte = false;

  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  constructor(private fichaDaObraService: FichaDaObraService) {}

  ngOnInit() {
    this.sucessoDescarteTarefa = false;
    this.confirmarDescarte = true;
  }

  continuar() {
    this.sucessoDescarteTarefa = false;
    this.close.emit();
  }

  fecharMensagemSucesso() {
    this.sucessoDescarteTarefa = false;
    this.close.emit();
  }

  onConfirmarDescarte(confirmar: boolean) {
    this.confirmarDescarte = false;
    if (confirmar) {
      this.loading.emit(true);
      this.descartarTarefa();
    } else {
      this.close.emit();
    }
  }

  descartarTarefa() {
    this.loading.emit(true);

    let tasksID = this.tarefa?.raw?.taskID;
    if (Array.isArray(tasksID)) {
      tasksID = tasksID.map((id) => `"${id}"`).join(','); 
    } else if (tasksID) {
      tasksID = `${tasksID}`; 
    }

    const payload = {
      tasksID: tasksID, 
    };


    this.fichaDaObraService.deletarTarefa(payload).subscribe({
      next: () => {
        this.loading.emit(false);
        this.sucessoDescarteTarefa = true;
        this.tarefaDescartada.emit();
      },
      error: () => {
        this.loading.emit(false);
      },
    });
  }
}
